import LoadingTable from "./table";

export default LoadingTable;
